import React, { useEffect, useState, createElement } from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { WistiaVideo } from '../components/WistiaVideo';
export function LandingPage() {
  useEffect(() => {
    // Meta Pixel Code
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [] as any[];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s.parentNode?.insertBefore(t, s);
    f.fbq('init', '1288215226741477');
    f.fbq('track', 'PageView');
    // noscript fallback
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=1288215226741477&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      document.body.removeChild(noscriptImg);
    };
  }, []);
  const scrollToRegistro = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    e.preventDefault();
    const element = document.getElementById('registro');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-[#5D2B85] text-gray-100 font-sans selection:bg-blue-500/30" data-id="element-2">
      {/* BARRA STICKY SUPERIOR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#FFD700] shadow-lg" data-id="element-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
          <div className="flex items-center justify-center h-14 text-sm sm:text-base text-center" data-id="element-5">
            <span className="text-black font-bold" data-id="element-6">
              ⚠️ El registro cierra el 13 de abril a las 11:59pm · Cupos
              limitados
            </span>
          </div>
        </div>
      </div>

      {/* SECCIÓN 1 — HERO */}
      <section className="pt-32 pb-16 lg:pt-40 lg:pb-24 bg-[#5D2B85]" data-id="element-7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-9">
            <div className="space-y-8" data-id="element-10">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-[#FFAB03] pt-[0px] pb-[0px] pl-[015px] pr-[015px]" data-id="element-11">
                Descubre por qué llevas años intentando cambiar — y nada
                funciona.
              </h1>
              <div className="w-full rounded-2xl overflow-hidden" data-id="element-12">
                <WistiaVideo mediaId="uoyvyozfhg" aspectRatio={16 / 9} className="w-full" data-id="element-13" />
              </div>
              <p className="text-xl text-gray-300 leading-relaxed" data-id="element-14">
                En esta masterclass virtual Jaime Nieto te revela el código
                exacto que tiene a tu mente repitiendo los mismos límites — y
                cómo romperlo de una vez. Virtual · 14 de abril · 8pm Colombia ·
                $2 USD
              </p>
              <div className="inline-block bg-[#FFA903] rounded-lg px-6 py-4 border border-gray-700" data-id="element-15">
                <p className="font-medium text-[#000000]" data-id="element-16">
                  +12,000 personas transformadas · 9 países · 10 años de
                  resultados reales
                </p>
              </div>
              <p className="text-lg text-white font-bold text-center leading-relaxed py-4 pl-5 bg-[#3D1F6E] rounded-lg border-l-[3px] border-[#FFD700]" data-id="element-17">
                En 90 minutos vas a salir
                <br data-id="element-18" />
                con tu código escrito
                <br data-id="element-19" />
                en una frase —<br data-id="element-20" />
                en tu propio cuaderno.
                <br data-id="element-21" />
                <span className="italic" data-id="element-22">Por primera vez visible.</span>
              </p>
            </div>

            <div className="rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-700 bg-[#FFFFFF]" data-id="element-23">
              <h3 className="text-2xl font-bold text-[#000000] mb-6 text-center" data-id="element-24">
                RESERVA TU LUGAR
              </h3>
              <a href="https://checkout.bold.co/payment/LNK_ZI612LLVLE" target="_blank" rel="noopener noreferrer" onClick={() => {
              const f = window as any;
              if (f.fbq) f.fbq('track', 'InitiateCheckout');
            }} className="block w-full text-center bg-[#1F7A4C] hover:bg-[#17663F] text-white font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#1F7A4C]/20 transition-all transform hover:scale-105" data-id="element-25">
                Reserva mi lugar por $2
              </a>
              <p className="text-center text-[#000000] mt-6 text-sm flex items-center justify-center gap-2" data-id="element-26">
                🔒 Pago seguro · $2 USD · 14 de abril · 8pm Colombia
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2 — PAIN POINTS */}
      <section className="py-16 lg:py-24 bg-[#5D2B85] border-t border-gray-800" data-id="element-27">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-12 text-center" data-id="element-29">
            Si alguna vez te dijiste esto — esta masterclass es para ti.
          </h2>
          <ul className="space-y-6 mb-12" data-id="element-30">
            {['Llevas años leyendo libros y tomando cursos pero algo sigue igual', 'Sabes exactamente lo que quieres pero algo te tiene paralizado', 'Empiezas con todo y a mitad del camino siempre te detienes', 'Sientes que puedes más — pero no entiendes por qué no lo estás haciendo', 'Ya intentaste de todo — y el problema sigue siendo el mismo', 'La motivación te dura tres días y después todo vuelve a ser igual'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-300" data-id="element-31">
                <ArrowRight className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" data-id="element-32" />
                <span data-id="element-33">{point}</span>
              </li>)}
          </ul>
          <p className="text-xl text-[#000000] leading-relaxed bg-[#FFA903] p-8 rounded-2xl border border-gray-700" data-id="element-34">
            No es falta de información. No es falta de fuerza de voluntad. No es
            que no seas suficiente. Hay un código en tu mente que está
            repitiendo el mismo límite una y otra vez. En El Código del Límite
            vas a descubrir cuál es el tuyo — y cómo romperlo.
          </p>
        </div>
      </section>

      {/* SECCIÓN 3 — TESTIMONIALS */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-35">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
          <div className="text-center mb-16" data-id="element-37">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4" data-id="element-38">
              Ellos también tenían un código. Esto es lo que pasó cuando lo
              rompieron.
            </h2>
            <p className="text-xl text-gray-600" data-id="element-39">
              Grabados en caliente · Sin guión · Solo la verdad de lo que
              vivieron.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-40">
            {/* TARJETA 1 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-41">
              <WistiaVideo mediaId="wum5peq71x" aspectRatio={1} className="w-full" data-id="element-42" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-43">
                <p className="font-bold text-gray-900 mb-4" data-id="element-44">
                  PATRICIA · Miami · Poder Total
                </p>
                <p className="text-gray-600 italic flex-1" data-id="element-45">
                  "Era una persona que dudaba mucho de sí misma. Empezaba cosas
                  y no terminaba. Hoy me miro al espejo y digo — ¡guau! Puedo
                  reconocer mi valor y mi poder que siempre estuve buscando en
                  otras personas."
                </p>
              </div>
            </div>

            {/* TARJETA 2 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-46">
              <WistiaVideo mediaId="tu10u96bf0" aspectRatio={1} className="w-full" data-id="element-47" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-48">
                <p className="font-bold text-gray-900 mb-4" data-id="element-49">
                  DAMIÁN BECHARA · Miami · Poder Total
                </p>
                <p className="text-gray-600 italic flex-1" data-id="element-50">
                  "Era un hombre inseguro con cero contacto personal con nadie.
                  Vivía en mi mundo pensando que era perfecto — al final era
                  mentira. Lo descubrí aquí."
                </p>
              </div>
            </div>

            {/* TARJETA 3 */}
            <div className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-100 flex flex-col" data-id="element-51">
              <WistiaVideo mediaId="aiwb3nck8w" aspectRatio={1} className="w-full" data-id="element-52" />
              <div className="p-6 flex-1 flex flex-col" data-id="element-53">
                <p className="font-bold text-gray-900 mb-4" data-id="element-54">
                  LORENA · Miami · Poder Total
                </p>
                <p className="text-gray-600 italic flex-1" data-id="element-55">
                  "Era una mujer que no confiaba en mí. Descubrí que la sanación
                  está interna — no tenía nada que ver con una condición médica.
                  Hoy soy una mujer libre de tomar cualquier elección en su
                  vida."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — VALUE PROPOSITION */}
      <section className="py-16 lg:py-24 bg-[#5D2B85]" data-id="element-56">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
          <h2 className="text-3xl lg:text-4xl font-bold mb-8 text-[#FFA903]" data-id="element-58">
            Una masterclass que no te va a dar más información. Te va a dar algo
            diferente.
          </h2>
          <p className="text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-59">
            La mayoría de personas que no logran lo que quieren no tienen un
            problema de información. Tienen un código instalado en su mente que
            los regresa al mismo lugar cada vez que intentan avanzar. Como un
            sistema operativo desactualizado — no importa cuántas apps nuevas
            instales — sigue fallando de la misma manera.
          </p>
          <ul className="space-y-6 mb-12" data-id="element-60">
            {['Qué es el código del límite y cómo se instala en tu mente sin que te des cuenta', 'Por qué la información sola nunca ha podido romperlo y nunca lo va a poder romper', 'El proceso exacto para identificar tu código específico — y lo que necesitas para reescribirlo'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-300" data-id="element-61">
                <ArrowRight className="w-6 h-6 text-blue-500 flex-shrink-0 mt-1" data-id="element-62" />
                <span data-id="element-63">{point}</span>
              </li>)}
          </ul>
          <p className="text-2xl font-bold text-white bg-blue-900/30 p-6 rounded-xl border border-blue-500/30" data-id="element-64">
            90 minutos que van a explicar lo que años de intentarlo solo no han
            podido resolver.
          </p>
        </div>
      </section>

      {/* SECCIÓN 5 — ABOUT JAIME */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-65">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-66">
          <h2 className="text-3xl lg:text-4xl font-bold text-center mb-16" data-id="element-67">
            El hombre que descifró el código
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-68">
            <div className="aspect-square bg-gray-200 rounded-3xl overflow-hidden relative shadow-xl" data-id="element-69">
              {/* Placeholder de foto de Jaime Nieto */}
              <img src="https://cdn.magicpatterns.com/uploads/5CP4tbZwnSp4ern6jPcPBL/Portada_Jaime_Bogota_(1)_(1).jpg" alt="Jaime Nieto" className="absolute inset-0 w-full h-full object-cover mt-[0px] mb-[0px] ml-[015px] mr-[015px]" data-id="element-70" />
            </div>
            <div data-id="element-71">
              <p className="text-xl text-gray-700 leading-relaxed" data-id="element-72">
                Jaime Nieto no siempre supo cuál era su código. Hubo un momento
                en su vida donde también estaba atrapado. Donde también sabía lo
                que quería pero algo lo detenía. La diferencia es que encontró
                la manera de romperlo. No con más información. No con más
                motivación. Con un proceso que va directo al origen del límite —
                porque el cambio real no ocurre solo en la cabeza. Hoy — después
                de 10 años — más de 12,000 personas en 9 países han descifrado
                su código. El 14 de abril es tu turno.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — MASTERCLASS STRUCTURE */}
      <section className="py-16 lg:py-24 bg-[#5D2B85]" data-id="element-73">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
          <h2 className="text-3xl lg:text-4xl font-bold text-[#FFA903] mb-16 text-center max-w-4xl mx-auto" data-id="element-75">
            En 90 minutos vas a entender lo que años intentándolo solo no te han
            podido explicar.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-76">
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-77">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-78">
                BLOQUE 1 — EL DIAGNÓSTICO
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-79">
                ¿Qué es el código del límite y cómo se instaló en ti sin que lo
                vieras?
              </p>
            </div>
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-80">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-81">
                BLOQUE 2 — EL PORQUÉ
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-82">
                ¿Por qué todo lo que has intentado antes no ha funcionado — y
                qué tiene que cambiar?
              </p>
            </div>
            <div className="bg-[#FFA903] rounded-2xl p-8 border border-gray-700 shadow-xl" data-id="element-83">
              <h3 className="text-xl font-bold text-[#000000] mb-4" data-id="element-84">
                BLOQUE 3 — EL PROCESO
              </h3>
              <p className="text-[#000000] text-lg" data-id="element-85">
                ¿Qué necesitas para reescribir tu código específico — y cómo se
                ve eso en la práctica?
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 7 — IDEAL ATTENDEE */}
      <section className="py-16 lg:py-24 bg-white text-gray-900" data-id="element-86">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
          <h2 className="text-3xl lg:text-4xl font-bold mb-12 text-center" data-id="element-88">
            Esta masterclass es para ti si...
          </h2>
          <ul className="space-y-6 bg-gray-50 p-8 sm:p-12 rounded-3xl border border-gray-100 shadow-sm" data-id="element-89">
            {['Sientes que hay una versión de ti que no has podido alcanzar todavía', 'Ya intentaste cambiar algo y el mismo patrón sigue apareciendo', 'Quieres entender de verdad qué es lo que te tiene frenado', 'Estás dispuesto a ver algo que quizás no has querido ver antes', 'Tienes 90 minutos el 14 de abril para invertir en lo más importante — tú mismo'].map((point, i) => <li key={i} className="flex items-start gap-4 text-lg text-gray-700" data-id="element-90">
                <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-91" />
                <span data-id="element-92">{point}</span>
              </li>)}
          </ul>
        </div>
      </section>

      {/* SECCIÓN 8 — REGISTRATION */}
      <section id="registro" className="py-16 lg:py-24 bg-[#5D2B85] scroll-mt-14" data-id="element-93">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-95">
            <div className="space-y-8" data-id="element-96">
              <h2 className="text-3xl lg:text-5xl font-bold text-[#FFA903]" data-id="element-97">
                Tu lugar en El Código del Límite
              </h2>
              <ul className="space-y-4" data-id="element-98">
                {['90 minutos en vivo con Jaime Nieto', 'Workbook de trabajo previo a la masterclass', 'Grabación de la sesión por 48 horas', 'Acceso al chat en vivo durante la masterclass', 'Sesión de preguntas y respuestas al final'].map((point, i) => <li key={i} className="flex items-center gap-3 text-lg text-gray-300" data-id="element-99">
                    <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-100" />
                    <span data-id="element-101">{point}</span>
                  </li>)}
              </ul>
              <div className="bg-[#FFA903] rounded-xl p-6 border border-gray-700 mt-8" data-id="element-102">
                <p className="text-[#000000]" data-id="element-103">
                  🔒 Riesgo cero. Si en los primeros 20 minutos sientes que no
                  es lo que esperabas — te devolvemos los $2 USD. Sin preguntas.
                  Sin procesos.
                </p>
              </div>
            </div>

            <div className="rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-700 flex flex-col items-center justify-center bg-[#FFFFFF]" data-id="element-104">
              <a href="https://checkout.bold.co/payment/LNK_ZI612LLVLE" target="_blank" rel="noopener noreferrer" onClick={() => {
              const f = window as any;
              if (f.fbq) f.fbq('track', 'InitiateCheckout');
            }} className="block w-full text-center bg-[#1F7A4C] hover:bg-[#17663F] text-white font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#1F7A4C]/20 transition-all transform hover:scale-105" data-id="element-105">
                Reserva mi lugar por $2
              </a>
              <p className="text-center text-[#000000] mt-6 text-sm flex items-center justify-center gap-2" data-id="element-106">
                🔒 Pago seguro · $2 USD · 14 de abril · 8pm Colombia
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 9 — FAQ */}
      <section className="py-16 lg:py-24 bg-[#1a0a2e]" data-id="element-107">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
          <h2 className="text-3xl lg:text-4xl font-bold mb-12 text-center text-white" data-id="element-109">
            Lo que la gente pregunta antes de registrarse
          </h2>
          <div className="divide-y divide-gray-700/50" data-id="element-110">
            <div className="py-8" data-id="element-111">
              <p className="font-bold text-white text-lg mb-3" data-id="element-112">
                ¿Necesito haber hecho algún proceso de desarrollo personal
                antes?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-113">
                No. Esta masterclass es para cualquier persona que siente que
                algo la ha frenado — sin importar si ha hecho procesos antes o
                no.
              </p>
            </div>
            <div className="py-8" data-id="element-114">
              <p className="font-bold text-white text-lg mb-3" data-id="element-115">
                ¿Es una masterclass grabada o en vivo?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-116">
                Es 100% en vivo. Vas a estar con Jaime Nieto en tiempo real. Hay
                grabación disponible por 48 horas después del evento.
              </p>
            </div>
            <div className="py-8" data-id="element-117">
              <p className="font-bold text-white text-lg mb-3" data-id="element-118">
                ¿Qué necesito para conectarme?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-119">
                Solo internet y un dispositivo. La masterclass es por Zoom. El
                link te llega por email y WhatsApp el 14 de abril a las 7pm —
                una hora antes de empezar.
              </p>
            </div>
            <div className="py-8" data-id="element-120">
              <p className="font-bold text-white text-lg mb-3" data-id="element-121">
                ¿Puedo ver la grabación si no puedo conectarme en vivo?
              </p>
              <p className="text-gray-400 text-lg leading-relaxed" data-id="element-122">
                Sí. Tienes acceso a la grabación por 48 horas después del
                evento. Pero te recomendamos conectarte en vivo — el ejercicio
                del código funciona mejor en tiempo real.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 10 — FINAL CTA */}
      <section className="py-16 lg:py-24 bg-[#5D2B85] text-center" data-id="element-123">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
          <h2 className="text-4xl lg:text-6xl font-bold text-[#FFA903] mb-8" data-id="element-125">
            El código no desaparece solo.
          </h2>
          <p className="text-xl text-gray-300 mb-12 leading-relaxed text-left sm:text-center" data-id="element-126">
            Lorena llevaba años con fibromialgia sin saber que el origen estaba
            en ella. Damián pensaba que sus relaciones eran perfectas — hasta
            que descubrió que eran mentira. Patricia empezaba todo — y no
            terminaba nada. Los tres tenían algo en común. No les faltaba
            información. No les faltaba fuerza de voluntad. Tenían un código
            instalado que nadie les había mostrado. Hasta que lo vieron. El 14
            de abril Jaime te muestra el tuyo. En 90 minutos. La pregunta no es
            si puedes permitirte venir a esta masterclass. La pregunta es cuánto
            te está costando seguir sin descifrar tu código.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-127">
            <p className="text-gray-400" data-id="element-128">
              🔒 Riesgo cero · $2 USD · Devolución garantizada en los primeros
              20 minutos
            </p>
            <a href="https://checkout.bold.co/payment/LNK_ZI612LLVLE" target="_blank" rel="noopener noreferrer" onClick={() => {
            const f = window as any;
            if (f.fbq) f.fbq('track', 'InitiateCheckout');
          }} className="w-full sm:w-auto block text-center bg-[#1F7A4C] hover:bg-[#17663F] text-white font-bold text-xl sm:text-2xl px-8 py-6 rounded-2xl shadow-[0_4px_14px_rgba(0,0,0,0.25)] border border-[#1F7A4C]/20 transition-all transform hover:scale-105" data-id="element-129">
              Reserva mi lugar por $2
            </a>
            <p className="text-yellow-500 font-medium mt-4" data-id="element-130">
              ⚠️ El registro cierra el 13 de abril a las 11:59pm. Después de esa
              hora — no hay más cupos.
            </p>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-950 py-12 border-t border-gray-800" data-id="element-131">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center space-y-6" data-id="element-132">
          <img src="https://cdn.magicpatterns.com/uploads/6n6s8z46Sz5qmSHydieLVh/LOGO_TRILOGY_350_X_180_(1080_x_1080_px).png" alt="Logo Trilogy" className="h-16 w-auto object-contain mb-4" data-id="element-133" />
          <div className="space-y-2 text-gray-400" data-id="element-134">
            <p data-id="element-135">El Código del Límite · Masterclass Virtual con Jaime Nieto</p>
            <p data-id="element-136">14 de abril · 8pm Colombia · $2 USD</p>
            <p data-id="element-137">WhatsApp: [número] · Email: [email]</p>
          </div>
          <p className="text-gray-600 text-sm pt-8" data-id="element-138">
            © 2025 Trilogy · Todos los derechos reservados
          </p>
        </div>
      </footer>
    </div>;
}